import { buildTheme } from "./designSystem";
import { ds } from "./tokens";

// Tema usato prima che App.tsx carichi i colori del brand: stessi componenti, colori di default.
export default buildTheme({
  primary: ds.primary,
  primaryHover: ds.primaryHover,
  secondary: ds.primary,
});
